// extracted by mini-css-extract-plugin
export default {"layerFooter":"LayerFooter__layerFooter___IcQ8l"};